import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
export let EExternalPayerSource;
(function (EExternalPayerSource) {
  EExternalPayerSource["NextgenTransactionHub"] = "nextgentransactionhub";
  EExternalPayerSource["Changehealthcare"] = "changehealthcare";
})(EExternalPayerSource || (EExternalPayerSource = {}));
export const fieldsInsurancePayor = _extends({}, fieldsIBaseModelWithUser, {
  address: {
    type: 'Text'
  },
  address2: {
    type: 'Text'
  },
  city: {
    type: 'Text'
  },
  country: {
    type: 'Text'
  },
  externalId: {
    type: 'Object'
  },
  externalIdentifiers: {
    type: 'Object',
    array: true
  },
  friendlyName: {
    type: 'Text'
  },
  name: {
    type: 'Text'
  },
  phone: {
    type: 'Text'
  },
  postcode: {
    type: 'Text'
  },
  state: {
    type: 'Text'
  }
});